import { iranSans } from './typography';

export const fontTheme = {
  MuiCssBaseline: {
    styleOverrides: {
      '@global': {
        ':root': {
          '--font-iran-sans': iranSans.style.fontFamily,
        },
      },
    },
  },
};
